import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface KsefGetHashQueryParams {
    id: number;
}

export interface KsefGetHashQueryResult {
    readonly ksefHash: string;
}

export class KsefGetHashQuery extends Query<KsefGetHashQueryResult | undefined> {
    public constructor(public readonly params: KsefGetHashQueryParams) {
        super();
    }
}

export class KsefGetHashQueryHandlerBase implements QueryHandler<KsefGetHashQuery> {
    private static Url = TaggedUrl.join('eInvoices/:id/hash', [Tags.Api, Tags.OmitMessage]);

    private readonly logger = new ConsoleLogger(this.constructor.name);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: KsefGetHashQuery): Promise<KsefGetHashQueryResult | undefined> {
        try {
            const url = fillPlaceholders(KsefGetHashQueryHandlerBase.Url, { id: params.id });
            const { data } = await this.http.get<KsefGetHashQueryResult>(url);

            return data;
        } catch (err) {
            this.logger.error(err);
        }
        return undefined;
    }
}
